import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Selector } from 'sonata-react-components';

import { FiltersSelectorsStyled } from './FiltersSelectors.styles';

import type { SelectorOptionPropsInterface } from 'sonata-react-components';

type State = {
  id: string;
  value: string;
}[];

type Props = {
  appAndSitesOptions: SelectorOptionPropsInterface[];
  countryOptions: SelectorOptionPropsInterface[];
  creativeSizeOptions: SelectorOptionPropsInterface[];
  isLoading: boolean;
  onFilterStatus?: (state: State) => void;
  publisherOptions: SelectorOptionPropsInterface[];
  sourceTypeOptions: SelectorOptionPropsInterface[];
  supplySourceOptions: SelectorOptionPropsInterface[];
};

export function FiltersSelectors({
  appAndSitesOptions,
  countryOptions,
  creativeSizeOptions,
  isLoading,
  onFilterStatus,
  publisherOptions,
  sourceTypeOptions,
  supplySourceOptions
}: Props) {
  const { formatMessage } = useIntl();

  const [state, setState] = useState<{ id: string; value: any }[]>([]);

  const handleChange = (id: string, val: SelectorOptionPropsInterface[]) => {
    const newState = state.find(filter => filter.id === id)
      ? state.map(filter =>
          filter.id === id
            ? {
                id,
                value: val
              }
            : filter
        )
      : [
          ...state,
          {
            id,
            value: val
          }
        ];
    setState(newState);
    onFilterStatus?.(newState);
  };

  return (
    <FiltersSelectorsStyled className="filtersSelectors">
      <div className="filtersSelectors__container">
        <Selector
          className="filtersSelectors__country"
          id="filtersSelectors-country"
          isDisabled={isLoading}
          onChange={value => handleChange('country', value as SelectorOptionPropsInterface[])}
          options={countryOptions}
          placeholder={formatMessage({
            defaultMessage: 'Country',
            id: 'appAndSiteMarketplace.dealSelection.filters.country'
          })}
          showSelectedItems={false}
          type="multiple"
        />
        <Selector
          className="filtersSelectors__appAndSite"
          id="filtersSelectors-appAndSite"
          isDisabled={isLoading}
          onChange={value => handleChange('appAndSite', value as SelectorOptionPropsInterface[])}
          options={appAndSitesOptions as SelectorOptionPropsInterface[]}
          placeholder={formatMessage({
            defaultMessage: 'App & Site',
            id: 'appAndSiteMarketplace.dealSelection.filters.appAndSite'
          })}
          showSelectedItems={false}
          type="multiple"
        />
        <Selector
          className="filtersSelectors__creativeSize"
          id="filtersSelectors-creativeSize"
          isDisabled={isLoading}
          onChange={value => handleChange('creativeSize', value as SelectorOptionPropsInterface[])}
          options={creativeSizeOptions}
          placeholder={formatMessage({
            defaultMessage: 'Creative Size',
            id: 'appAndSiteMarketplace.dealSelection.filters.creativeSize'
          })}
          showSelectedItems={false}
          type="multiple"
        />
        <Selector
          className="filtersSelectors__publisher"
          id="filtersSelectors-publisher"
          isDisabled={isLoading}
          onChange={value => handleChange('publisher', value as SelectorOptionPropsInterface[])}
          options={publisherOptions}
          placeholder={formatMessage({
            defaultMessage: 'Publisher',
            id: 'appAndSiteMarketplace.dealSelection.filters.publisher'
          })}
          showSelectedItems={false}
          type="multiple"
        />
        <Selector
          className="filtersSelectors__supplySource"
          id="filtersSelectors-supplySource"
          isDisabled={isLoading}
          onChange={value => handleChange('supplySource', value as SelectorOptionPropsInterface[])}
          options={supplySourceOptions}
          placeholder={formatMessage({
            defaultMessage: 'Supply Source',
            id: 'appAndSiteMarketplace.dealSelection.filters.supplySource'
          })}
          showSelectedItems={false}
          type="multiple"
        />
        <Selector
          className="filtersSelectors__sourceType"
          id="filtersSelectors-sourceType"
          isDisabled={isLoading}
          onChange={value => handleChange('sourceType', value as SelectorOptionPropsInterface[])}
          options={sourceTypeOptions}
          placeholder={formatMessage({
            defaultMessage: 'Source Type',
            id: 'appAndSiteMarketplace.dealSelection.filters.sourceType'
          })}
          showSelectedItems={false}
          type="multiple"
        />
      </div>
    </FiltersSelectorsStyled>
  );
}
